import React from 'react';

import { SpaceAnalyticsPageLoader } from '@confluence/confluence-analytics/entry-points/SpaceAnalyticsPage.ts';
import { CONTAINER_ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { SPACE_ANALYTICS } from '@confluence/named-routes/entry-points/routes.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';
import { expVal } from '@confluence/feature-experiments';

import { NotFound } from '../NotFound.tsx';
import SpaceBase from '../../SpaceBase/index.js';

export const SpaceAnalyticsRoute: {
	({ params: { spaceKey, tab } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ name, params: { spaceKey, tab } }: RouteMatch):
		| false
		| {
				Screen: {
					pageState: {
						routeName: string;
						spaceKey: string;
						tab: string;
					};
				};
				MainLayout: {
					spaceKey: string;
					navView: string;
				};
		  };
} = ({ params: { spaceKey, tab } }: RouteMatch): React.JSX.Element => {
	if (tab === 'activity' && !expVal('ai_agent_analytics', 'isEnabled', false)) {
		return <NotFound />;
	}

	if (tab === 'users' && expVal('ai_agent_analytics', 'isEnabled', false)) {
		return <Redirection name={SPACE_ANALYTICS.name} params={{ spaceKey, tab: 'activity' }} />;
	}

	return (
		<SpaceBase>
			<SpaceAnalyticsPageLoader spaceKey={spaceKey} />
		</SpaceBase>
	);
};

SpaceAnalyticsRoute.NAVIGATION_PARAMS = ({
	name,
	params: { spaceKey, tab },
}: RouteMatch):
	| false
	| {
			Screen: {
				pageState: {
					routeName: string;
					spaceKey: string;
					tab: string;
				};
			};
			MainLayout: {
				spaceKey: string;
				navView: string;
			};
	  } => {
	if (
		(tab === 'activity' && !expVal('ai_agent_analytics', 'isEnabled', false)) ||
		(tab === 'users' && expVal('ai_agent_analytics', 'isEnabled', false))
	) {
		return false;
	}

	return {
		Screen: {
			pageState: {
				routeName: name,
				spaceKey,
				tab: tab === 'activity' ? 'users' : tab,
			},
		},
		MainLayout: {
			spaceKey,
			navView: CONTAINER_ADMIN_HOME_ID,
		},
	};
};
